import { Component, Input } from '@angular/core';
import { ActivatablePackage } from '../../../../core/interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-activatable-package-row]',
  templateUrl: './activatable-package-row.component.html',
  styleUrls: ['./activatable-package-row.component.scss'],
})
export class ActivatablePackageRowComponent {
  @Input() activatablePackage: ActivatablePackage;
  @Input() indented = false;
}
